import { useMutation } from "@shared/lib/hooks";
import { FinanceApprovalService } from "../services/FinanceApprovalService";
import { ToastService } from "@shared/lib/services";
import {
  FINANCE_APPROVAL_QUERY_KEY,
  FINANCE_APPROVAL_QUERY_KEY_ID,
} from "../constants";
import {
  BRIEF_LIST_QUERY_KEY,
  BRIEF_LOT_FACETS_QUERY_KEY,
} from "@entities/brief/lib/constants";

export function useRejectFinanceApprovalLots(lotId: string, briefId: string) {
  const {
    mutate: rejectLots,
    isLoading: isRejecting,
    isSuccess: isRejected,
    variables,
  } = useMutation({
    mutationFn: ({ ids, reason }: { ids: string[]; reason: string }) =>
      FinanceApprovalService.rejectFinanceApprovalLotIds(
        lotId,
        ids,
        reason
      ).catch(async (err) => {
        const responseBody = await err.response.json();
        ToastService.error(responseBody.msg);
        throw err;
      }),
    options: {},
    onSuccess: (c) => {
      c.invalidateQueries({
        queryKey: [...BRIEF_LOT_FACETS_QUERY_KEY(briefId)],
      });
      c.invalidateQueries({
        queryKey: [...FINANCE_APPROVAL_QUERY_KEY],
      });
      c.invalidateQueries({
        queryKey: [...FINANCE_APPROVAL_QUERY_KEY_ID(lotId)],
      });
      c.invalidateQueries({
        queryKey: [...BRIEF_LIST_QUERY_KEY, briefId],
      });
    },
  });

  return {
    rejectLots,
    isRejecting,
    isRejected,
    variables,
  };
}
